<template>

  <svg
    t="1639131648079"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="3988"
    width="64"
    height="64"
  ><path d="M512 102.00000031C285.99999969 102.00000031 102.00000031 285.99999969 102.00000031 512S285.99999969 921.99999969 512 921.99999969 921.99999969 738.00000031 921.99999969 512 738.00000031 102.00000031 512 102.00000031zM861.99999969 512c0 79.99999969-28.00000031 154.00000031-73.99999969 214.00000031l-499.99999969-482.00000062c60-52.00000031 139.99999969-82.00000031 223.99999969-81.99999938 192 0 349.99999969 157.99999969 349.99999969 349.99999969z m-699.99999938 0c0-85.99999969 31.99999969-163.99999969 81.99999938-226.00000031l502.00000031 484.00000031c-61.99999969 55.99999969-144 91.99999969-235.99999969 91.99999969-190.00000031 0-348-157.99999969-348-349.99999969z" p-id="3989" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconStop',
} as DefineComponent
</script>